// Acconti del preventivo [sc-49299]: ogni versamento ha importo, metodo e
// data (`quote.payments`); l'importo complessivo resta `quote.deposit`.

import { formatToLocalDate } from "./formatting";

export const METODI_ACCONTO = [
  "Contanti",
  "Bonifico",
  "Carta di credito",
  "Assegno",
];

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

/** Metodo proposto: quello del preventivo, se è uno dei quattro. */
export function metodoIniziale(quote) {
  const m = quote?.payment_method;
  return METODI_ACCONTO.includes(m) ? m : "";
}

/** «Acconto 12/10/2026 · Bonifico»; senza metodo solo la data. */
export function etichettaAcconto(p) {
  const data = formatToLocalDate(p?.paidAt);
  return ["Acconto" + (data ? ` ${data}` : ""), p?.method]
    .filter(Boolean)
    .join(" · ");
}

/**
 * Versamenti in ordine di data, se sommano all'acconto complessivo; altrimenti
 * null, e chi li usa mostra la sola riga «Acconto» (cifre sempre coerenti).
 */
export function versamentiCoerenti(payments, deposito) {
  const lista = [...(payments || [])]
    .filter((p) => Number(p.amount) > 0)
    .sort(
      (a, b) =>
        new Date(a.paidAt) - new Date(b.paidAt) || (a.id || 0) - (b.id || 0)
    );
  if (!lista.length) return null;
  const somma = round2(lista.reduce((t, p) => t + Number(p.amount), 0));
  return Math.abs(somma - round2(Number(deposito) || 0)) < 0.005 ? lista : null;
}

/**
 * Righe del riepilogo PDF: una per versamento, o null (vedi sopra). Il metodo
 * va sotto la data, come nota piccola e grigia.
 */
export function righeAcconti(payments, deposito) {
  const lista = versamentiCoerenti(payments, deposito);
  return lista
    ? lista.map((p) => ({
        label: etichettaAcconto({ ...p, method: null }),
        ...(p.method ? { nota: p.method } : {}),
        amount: round2(Number(p.amount)),
      }))
    : null;
}
